/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import {
  IProductTabs,
  ProductTabStyleTypes,
} from "@/api/AppApi/services/home/interfaces/IProductTabs";
import { useEffect, useState } from "react";
import { Button, ButtonGroup, Spinner } from "@/utils/bootstrap";
import SvgTabIcon from "./SvgTabIcon";
import { useGetAllProductsInfiniteQuery } from "@/api/AppApi/services/product";
import ProductGrid from "../../product/product-grids/ProductGrid";
import { useIntersectionObserver as useInView } from "@/hooks/useIntersectionObserver";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";

interface Props extends IProductTabs {
  icon?: boolean;
}

const Tabs: React.FC<Props> = ({ icon, configurations, data }) => {
  const { data: companyData } = useGetCompanyQuery();
  const theme = companyData?.result?.theme;

  const [btnIndex, setBtnIndex] = useState(0);
  const { number_of_products, style_type, product_style_type } = configurations;

  const hasLimited = number_of_products > 0;
  const forced_limit = hasLimited ? number_of_products : 14;
  const inline = style_type !== ProductTabStyleTypes.button;

  const {
    data: productData,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  } = useGetAllProductsInfiniteQuery({
    params: { filter: data[btnIndex].filter, forced_limit },
  });

  const products =
    productData?.pages?.flatMap((page) => page.result.data) || [];

  const [ref, isInView] = useInView();

  const handleFetchNextPage = () => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  useEffect(() => {
    handleFetchNextPage();
  }, [isInView]);

  const getButtonClassName = (index: number) => {
    return inline
      ? `tab-btn ${
          index === btnIndex ? "tab-btn-selected" : "tab-btn-not-selected"
        }`
      : `tab-like-btn ${
          index === btnIndex
            ? "tab-like-btn-selected"
            : "tab-like-btn-not-selected"
        }`;
  };

  return (
    <>
      <div style={{ overflow: "auto", marginBottom: 16 }}>
        <ButtonGroup onClick={(e: any) => setBtnIndex(+e.target.value)}>
          {data?.map((tab, index) => (
            <Button
              key={index}
              value={index}
              className={getButtonClassName(index)}
            >
              {icon && (
                <span style={{ marginInlineEnd: 5.25 }}>
                  <SvgTabIcon
                    light={!inline && index === btnIndex}
                    dark={inline && index !== btnIndex}
                  />
                </span>
              )}
              {tab.title}
              {inline && (
                <div
                  style={{ marginTop: 6 }}
                  className={`${index === btnIndex ? "hor-line" : ""}`}
                />
              )}
            </Button>
          ))}
        </ButtonGroup>
      </div>

      <ProductGrid
        products={{
          data: products,
          configurations: { style_type: product_style_type },
        }}
        theme={theme!}
      />
      <div ref={ref} className="w-100 d-flex justify-content-center mt-3">
        {hasNextPage && <Spinner />}
      </div>
    </>
  );
};

export default Tabs;
